export function AnaliseSorriso() {
    return (
        <div>Analise do sorriso</div>
    )
}